import type { UserPageRolePrivList } from '@local/domain';

export class LoginUserPagePrivWrapper {
  public readonly isMaster: boolean;

  constructor(public readonly priv: UserPageRolePrivList[]) {
    this.isMaster = true;
  }
}
